import React from 'react'
import { LoginCallback, SecureRoute } from '@okta/okta-react'
import { Route, Switch } from 'react-router-dom'
import { Home } from '../../Home'
import { NotFound } from '../NotFound'
import { Loading } from '../../Loading'
import { Login } from '../../Login'
import { Logout } from '../../Logout'
import { Wrapper } from '../../../components/Wrapper'
import { PoseGroup } from 'react-pose'
import { Screen } from '../Screen'
import { DynamicRoutesWrapper } from './DynamicRoutes'
import { withRootPath } from '../../../components/hocs'
import { RouterProps } from '../types'
import { shimPathForInvestOps } from './shimPathForInvestOps'
import { FramedRenderer } from '../../../components/FramedRenderer'

export const Routes = withRootPath(
  ({ apps, appPaths, location, history, rootPath }: RouterProps) => {
    const callbackURL = '/login/callback'
    const logoutURL = '/logout'

    return (
      <Wrapper noWrapperRoutes={[callbackURL, logoutURL]}>
        <PoseGroup>
          <Screen key={rootPath}>
            <Switch location={location}>
              <Route exact key="login" path="/login" component={Login} />

              <SecureRoute exact key="home" path="/" component={Home} />

              {apps && appPaths && (
                <SecureRoute path={appPaths}>
                  <DynamicRoutesWrapper>
                    {apps?.map((app) => (
                      <Route
                        key={app.rootPath}
                        path={shimPathForInvestOps(app.rootPath)}
                        component={() => (
                          <FramedRenderer
                            app={app}
                            key={app.name}
                            location={location}
                            history={history}
                          />
                        )}
                      />
                    ))}
                  </DynamicRoutesWrapper>
                </SecureRoute>
              )}

              <Route
                key="loginCallback"
                path={callbackURL}
                component={() => <LoginCallback loadingElement={<Loading />} />}
              />

              <SecureRoute exact path="/logout" component={Logout} />

              <SecureRoute path="*" component={NotFound} />
            </Switch>
          </Screen>
        </PoseGroup>
      </Wrapper>
    )
  },
)
